import { useMutation } from "@tanstack/react-query"
import { axios } from "./axios"
import { useAuth } from "../context/AuthContext"
import { env } from "../utils/env"
import { MandateType } from "../types/MandateType"

/**
 * Write shape: the Divisions/Teams the type belongs to, as bare ids
 * (`"divisions": [1, 2], "teams": [1, 2]`).
 */
export type CreateMandateTypePayload = Omit<
  Partial<MandateType>,
  "primary_division" | "primary_team"
> & {
  divisions?: number[]
  teams?: number[]
}

export const useCreateMandateType = () => {
  const { authHeader } = useAuth()

  return useMutation((params: CreateMandateTypePayload) => {
    return axios.post<MandateType>(
      `${env.verifyServiceUrl}individual/mandate_type/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    )
  })
}
